import { State } from 'interfaces/state'
import { createSelector } from 'reselect'


export const sidebarSelector = (state: State) =>
  state.app.sidebar

export const stashCountersSelector = createSelector(
  sidebarSelector,
  (sidebar) => sidebar.counters.stash
)
